import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * ProductSchema component for structured data markup
 *
 * Only include aggregateRating when you have real verified reviews.
 * Fake ratings are a trust and SEO liability.
 *
 * @param {Object} props - Component props
 * @param {string} [props.ratingValue] - Aggregate rating (1-5); omit if none
 * @param {string} [props.reviewCount] - Review count; omit if none
 */
const ProductSchema = ({
  name = "TensorPilot",
  description = "TensorPilot brings AI models like Gemini, Claude, and OpenAI to your local files, code, and media, prioritizing privacy and efficiency.",
  image = "https://www.tensorpilot.io/Logo.png",
  category = "Software > Productivity",
  price = "0",
  priceCurrency = "USD",
  availability = "InStock",
  url = "https://www.tensorpilot.io",
  sku = "tensor-pilot",
  brand = "TensorPilot",
  ratingValue = null,
  reviewCount = null,
  features = [
    "AI-powered document assistance",
    "Code generation and review",
    "Local data processing for privacy",
    "Multiple AI model support"
  ]
}) => {
  const productData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": name,
    "applicationCategory": category,
    "operatingSystem": "Windows, macOS",
    "offers": {
      "@type": "Offer",
      "price": price,
      "priceCurrency": priceCurrency,
      "priceValidUntil": "2027-12-31",
      "availability": `https://schema.org/${availability}`
    },
    "description": description,
    "downloadUrl": "https://www.tensorpilot.io/download",
    "softwareVersion": "1.0",
    "fileSize": "100MB",
    "screenshot": {
      "@type": "ImageObject",
      "url": image
    },
    "url": url,
    "sku": sku,
    "brand": {
      "@type": "Brand",
      "name": brand
    },
    "featureList": features
  };

  if (ratingValue && reviewCount) {
    productData.aggregateRating = {
      "@type": "AggregateRating",
      "ratingValue": ratingValue,
      "reviewCount": reviewCount
    };
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(productData)}
      </script>
    </Helmet>
  );
};

export default ProductSchema;
